export enum mapTypes {
  google,
  apple,
  generic
}

export enum ButtonType {
  Transparent = 'transparent',
  Soft = 'soft',
  Outline = 'outline',
  Secondary = 'secondary',
  Link = 'link',
  Minimal = 'minimal',
  Solid = 'solid' // This is your default type
}

export enum comboBoxTypes {
  Transparent = 'transparent', // This is your default type
  Solid = 'solid'
}
